import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { Browser } from '@capacitor/browser';
import { Device } from "@capacitor/device";
import { AlertController, ModalController, NavParams, ToastController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { firstValueFrom, lastValueFrom } from "rxjs";
import { take, takeWhile } from "rxjs/operators";
import { LegalComponent } from "src/app/components/legal/legal.component";
import { NotificationCategoryModel, NotificationConfigModel, NotificationSubCategoryModel } from "src/app/models/notification.model";
import { OrderModel } from "src/app/models/order.model";
import { IPayment, IPaymentCard, IPaymentConfig } from "src/app/models/payment.model";
import { ProfileModel } from "src/app/models/profile.model";
import { UserModel } from "src/app/models/user.model";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import { DataService } from "src/app/services/data/data.service";
import { DateService } from "src/app/services/date/date.service";
import { HomeService } from "src/app/services/home-service/home.service";
import { MathService } from "src/app/services/math/math.service";
import { PaymentService } from "src/app/services/payment/payment.service";
import { appConfig, paymentConfig } from "../../../environments/environment";
//declare const mangoPay: any;

@Component({
  selector: "basket-order",
  templateUrl: "./basket-order.component.html",
  styleUrls: ["./basket-order.component.scss"]
})
export class BasketOrderComponent implements OnInit {
  // @ViewChild("orderSlider", { static: true }) orderSlider: IonSlides;

  @Input()
  title: string;

  @Input()
  mode: string; // edit, view, order, catalog, sale

  @Input()
  order: OrderModel;

  @Input()
  user: UserModel;

  @Input()
  sortBy: string;

  @Input()
  owner: ProfileModel;

  @Input()
  public onCancel = () => {};

  @Input()
  public onOrder = () => {};

  @Input()
  public onFinish = () => {};

  @Input()
  public onViewOrder = (order:OrderModel) => {}
 
  @Input()
  state:string = 'basket';

  paymentToken:string;

  @Output() orderDone = new EventEmitter<OrderModel>();

  notificationConfig:NotificationConfigModel = {categories:[]};
  formComment: UntypedFormGroup;
  formContract: UntypedFormGroup;
  formFullProfile: UntypedFormGroup;
  formAddress: UntypedFormGroup;
  formRegister: UntypedFormGroup;
  formPaymentContactDetails: UntypedFormGroup;
  // work around due to display issues with Safari. The autocomplete function of safari moves the slide until email and password fields are visible
  onSafari = false;
  loading = false;
  paymentLoading = false;
  deliveryTypesWithTimingAndPlace = ["market", "collectpoint", "ownshop", "pickupstore"];
  deliveryTypesWithName = ["pickupstore"];
  canOrder = true;
  canPay = false;
  shouldPay = false;
  hasSkippedPayment = false;
  canPayEntirely = false;
  cantOrderMessage = "";
  paymentConfig = paymentConfig;
  needsAddress = false;
  psp= '';
  processingMessage="";
  @Input()
  paymentKey:string;

  constructor(
    private dataService: DataService,
    private mathService: MathService,
    public formBuilder: UntypedFormBuilder,
    public auth: AuthenticationService,
    private translateService: TranslateService,
    private alertCtrl: AlertController,
    private navParams: NavParams,
    private homeService: HomeService,
    private toastCtrl: ToastController,
    private modalCtrl: ModalController,
    private paymentService: PaymentService,
    private dateService: DateService,
    // private iab: InAppBrowser
  ) {
    this.order = this.navParams.data.order;
    this.state = this.navParams.data.state;
    this.paymentKey = this.navParams.data.paymentKey;
    console.log('basket order: order, state',this.order, this.state);
    
    this.needsAddress =
      (this.order.market && this.order.market.details && this.order.market.details.deliveryType == "tournee") ||
      (this.order.tournee && this.order.tournee.details && this.order.tournee.details.deliveryType == "tournee");
    this.formComment = this.formBuilder.group({
      comment: [""],
    });

    this.formContract = this.formBuilder.group({
      contractAccepted: [this.order.details.termsAccepted, Validators.required]
    })

    this.formRegister = formBuilder.group({
      email: ["", Validators.compose([Validators.maxLength(100), Validators.email, Validators.required])],
      password: ["", Validators.compose([Validators.minLength(8), Validators.maxLength(50), Validators.required])]
    });

    this.formFullProfile = this.formBuilder.group({
      lastname: [null, Validators.compose([Validators.required])],
      firstname: [null, Validators.compose([Validators.required])],
      phone: [null, Validators.compose([Validators.required])]
    });
    if(this.order.consumer.details.fullDetails){
      this.formFullProfile.patchValue(this.order.consumer.details.fullDetails);
    }
    this.formAddress = this.formBuilder.group({
      geocoding: [null, Validators.compose([Validators.required])]
    });
    this.formPaymentContactDetails = this.formBuilder.group({
      address: [null, Validators.compose([Validators.required])],
      nationality:[null, Validators.compose([Validators.required])],
      birthdate:[null, Validators.compose([Validators.required])],
    });
    if(this.order.consumer.details.geocoding){
      // console.log('patch geocoding',this.order.consumer.details.geocoding);
      this.formAddress.patchValue(this.order.consumer.details);
    }

    this.setCanPay();
  }

  ngOnInit() {}

  ionViewDidEnter() {
    // this.orderSlider.lockSwipes(true);
    this.routeAfterPayment(this.state,this.order, this.paymentKey);
  }
  cancel() {
    this.onCancel();
  }

  setCanPay(){
    if(this.order.market){
      this.canPay = false;
    }
    else if(this.order.finances.totals.prepayable > 0 
        && this.paymentConfig.paymentEnabled 
        && this.order.tournee.details.paymentModes
        && (this.order.tournee.details.paymentModes.includes('lydia') || this.order.tournee.details.paymentModes.includes('mangoPay'))
        && this.order.producer.details.paymentModes
        && ((this.order.producer.details.paymentModes.mangopay && this.order.producer.details.paymentModes.mangopay.status == 'activated')
            || (this.order.producer.details.paymentModes.lydia && this.order.producer.details.paymentModes.lydia.status == 'activated'))
        // && this.order.finances.totals.prepayable > (this.order.tournee.producer.details.paymentModes.minimumAmount||10)
        ){
        this.canPay = true;
        if(this.order.tournee.details.paymentModes.includes('lydia') && this.order.producer.details.paymentModes.lydia && this.order.producer.details.paymentModes.lydia.status == 'activated'){
          this.psp = 'lydia';
        }
        else{
          this.psp = 'mangopay';
        }
        if(this.order.tournee.details.prepaymentPercentage > 0){
          this.shouldPay = true;
        }
        if(this.order.finances.totals.prepayable == this.order.finances.totals.sold){
          this.canPayEntirely = true;
        }
    }
    console.log('canPay',this.canPay);
  }

  async next(state: string) {
    // await this.orderSlider.lockSwipes(false);
    // BASKET
    if (state == "basket") {
      console.log('is lodded in', this.auth.isLoggedIn());
      if(this.auth.isLoggedIn() && (this.order.consumer && this.order.consumer.key)){
        if(this.formFullProfile.valid){
          if(!this.needsAddress){
            this.goToState('comment')
          }
          else{
            this.goToState('address')
          }
        }
        else{
            this.goToState('contact')
        }        
      }
      else{
        this.goToState('auth')
      }
    } 
    // AUTH
    else if (state == "auth" && this.formRegister.valid) {
      this.loading = true;
      this.user = {
        email: this.formRegister.value.email,
        password: this.formRegister.value.password
      };
      this.auth
        .register(this.user)
        .then(result => {
          // NEW USER
          console.log('new user', result);
          this.order.consumer.key = result.user.uid;
          this.dataService
            .updateUserSubscription(result.user as UserModel, { accountType: "consumer" })
            .then(() => {
              this.auth.setRole("consumer");
              this.goToState('contact');
              this.loading = false;
            })
            .catch(error => {
              console.log(error);
              this.goToState('contact');
              this.loading = false;

            });
        })
        .catch(error => {
          // EXISTING USER
          console.log(error, 'existing user');
          if (error.code == "auth/email-already-exists" || error.code == "auth/email-already-in-use") {
            this.auth
              .login(this.user)
              .then(async result => {
                this.order.consumer.key = result.uid;
                console.log(this.order.consumer, result);
                const details = await firstValueFrom(this.dataService.getConsumerDetails(result.uid));
                console.log(details);
                if (details && details.fullDetails) {
                  this.order.consumer.status = "enabled";
                  this.order.consumer.details = details;
                  this.formFullProfile.patchValue(this.order.consumer.details.fullDetails);
                  if(this.order.consumer.details.geocoding){
                    this.formAddress.patchValue(this.order.consumer.details);
                  }
                }
                if(this.formFullProfile.valid){
                  if(!this.needsAddress){
                    this.goToState('comment')
                  }
                  else{
                    this.goToState('address')
                  }
                }
                else{
                  this.goToState('contact')
                }
                this.loading = false;
              })
              .catch(error => {
                if (error.code == "auth/wrong-password") {
                  this.stayOnTheSlide(this.translateService.instant("errors.InvalidPassword"));
                } else {
                  this.dataService.logError("tournee-consumer", "login", error.code, error.code);
                  this.stayOnTheSlide(this.translateService.instant("errors.ErrorEncountered:") + error);
                }
                this.loading = false;
              });
          } else {
            this.dataService.logError("tournee-consumer", "register", error.code, error.code);
            this.stayOnTheSlide(this.translateService.instant("errors.ErrorEncountered:") + error);
            this.loading = false;
          }
        });
    } 
    // CONTACT
    else if (state == "contact" && this.formFullProfile.valid) {
      if(!this.order.consumer.details){
        this.order.consumer.details = {}
      }
      if(!this.order.consumer.details.fullDetails){
        this.order.consumer.details.fullDetails = {}
      }
      this.order.consumer.details.fullDetails.firstname = this.formFullProfile.value.firstname;
      this.order.consumer.details.fullDetails.lastname = this.formFullProfile.value.lastname;
      this.order.consumer.details.fullDetails.phone = this.formFullProfile.value.phone,
      this.order.consumer.details.fullProfile = true;
      this.order.consumer.details.shortDetails = {
        name: this.formFullProfile.value.firstname + " " + this.formFullProfile.value.lastname.slice(0, 1) + "."
      };
      await this.dataService.updateConsumerFullDetails(this.order.consumer);
      if (this.needsAddress) {
        this.goToState('address');
      } else {
        this.goToState('comment');
      }
    } 
    // ADDRESS
    else if (state == "address") {
      if(this.formAddress.valid){
        if(this.formAddress.value.geocoding.locationID != this.order.consumer.details.geocoding.locationID){
          this.order.consumer.details.geocoding = this.formAddress.value.geocoding;
          console.log('update consumer geocoding',this.order.consumer.details.geocoding);
          await this.dataService.updateConsumerGeocoding(this.order.consumer);
        }
        else{
          this.order.consumer.details.geocoding = this.formAddress.value.geocoding;
        }
        this.order.route.geocoding = this.formAddress.value.geocoding;
        this.goToState('comment');
      }
      else{
        this.stayOnTheSlide(this.translateService.instant("alerts.invalidFullAddress"));
      }

    } 
    // COMMENT
    else if (state == "comment") {
      this.order.details.comment = this.formComment.value.comment;
      this.goToState('paymentChoice');
    }

    // PAYMENT CHOICE
    else if (state == "paymentChoice") {
      this.order.details.termsAccepted = true;
      this.order.details.termsVersion = appConfig.termsVersion;
      this.paymentLoading = true;
      if(this.order.tournees){
        if(this.order.consumer.details.paymentModes && this.order.consumer.details.paymentModes.mangopay && this.order.consumer.details.paymentModes.mangopay.status == 'activated'){
            await this.launchPayment();
        }
        else{
          const paymentConfig:IPaymentConfig = {
            uid:this.order.consumer.key,
            mangopay:{
              user:{
                firstname: this.order.consumer.details.fullDetails.firstname,
                lastname: this.order.consumer.details.fullDetails.lastname,
                address: this.order.consumer.details.geocoding
              }
            } 
          }
          this.order.consumer.user = {payments:{config: paymentConfig}};
          this.formPaymentContactDetails.patchValue(this.order.consumer.user.payments.config.mangopay.user);
          this.goToState('paymentContact');
        }          
      }
      else{
        await this.launchPayment();
      }
      this.paymentLoading = false;
    }
    // PAYMENT CONTACT
    else if (state == "paymentContact" && this.formPaymentContactDetails.valid) {
      this.order.consumer.user.payments.config.mangopay.user.birthdate = this.dateService.setTimeToZero(this.formPaymentContactDetails.value.birthdate);
      this.order.consumer.user.payments.config.mangopay.user.nationality = this.formPaymentContactDetails.value.nationality;
      this.order.consumer.user.payments.config.mangopay.user.address = this.formPaymentContactDetails.value.address;
      //this.paymentService.registerCard()
      if(!this.order.consumer.details.paymentModes || !this.order.consumer.details.paymentModes.mangopay || this.order.consumer.details.paymentModes.mangopay.status!== 'activated'){
        try{
          const result = await this.paymentService.activatePayment(this.order.consumer.user.payments.config);
          console.log(result);
          await this.launchPayment();
        }
        catch(error){
          this.loading = false;
          this.presentToast(this.translateService.instant("payment.errors.ActivatePayment") + ": " + error);
          this.order.paymentStatus = "unpaid";
          // await this.confirmOrder(); 
          this.goToState('error');
        }
      }
    }
    // CARD
    else if (state == "paymentCard") {
      let payment:IPayment;
      let card:IPaymentCard;
      
      this.order.paymentStatus = "prepaid";
      this.goToState('orderConfirmation');
    }
    
    else if (state == "skipCard") {
      this.order.paymentStatus = "unpaid";
      this.goToState('orderConfirmation');
    }
    
    else if (state == "order") {
      this.loading = true;
      console.log('order');
      this.order.paymentStatus = "unpaid";
      this.saveOrder();
    } else if (state == "orderConfirmation"){
      this.onFinish();
    } else {
      this.stayOnTheSlide(this.translateService.instant("alerts.invalidForm"));
    }
  }

  async launchPayment(){
    console.log('launch payment');
    try{
      this.processingMessage = this.translateService.instant('payment.RedirectingToPSP');
      this.goToState("processing");
      const currency = this.order.market?this.order.market.details.currency:this.order.tournee.details.currency;
      const payment:IPayment = {
        debitedFunds:{
          currency: currency,
          amount: this.order.finances.totals.prepayable
        },
        cardType: 'CB_VISA_MASTERCARD'
      }
      if(this.order.market){
        payment.marketKey = this.order.market.key;
      }
      else{
        payment.tourneeKey = this.order.tournee.key;
      }
      this.order.status = 'draft';
      this.order.details.dateCreated = Date();
      this.order = this.mathService.calculateMultiOrder(this.order);
      let url = '';
      if(this.paymentKey && this.psp == 'lydia'){
        url = this.order.payments[this.paymentKey].redirectURL;
      }
      else{
        const deviceInfo = await Device.getInfo();
        const paymentResult = await this.paymentService.initiatePayment(payment,this.order,deviceInfo.platform);
        console.log('payment init result',payment,paymentResult);
        this.order.key = paymentResult.basketKey || null;
        url = paymentResult.redirectURL;
        
      }
      
      const browser = await Browser.open({ url: url, windowName:'_self' });
      console.log(browser);

    }
    catch(error){
      this.loading = false;
      this.presentToast(this.translateService.instant("payment.errors.CardPregistration") + ": " + error);
      this.order.paymentStatus = "unpaid";
      this.saveOrder();
      // this.confirmOrder(); 
    }
    try{

    }
    catch(error){

    }
  }

  listenToPaymentUpdate(paymentKey){
    console.log('listen to payment update');
    this.dataService.getPayment(paymentKey)
          .pipe(takeWhile(value => (value.status == 'new' || value.status == 'waiting')))
          .subscribe(
            value => {
              console.log(value);
              if(value.status =='paid'){
                this.order.payments[paymentKey] = value;
                this.routeAfterPayment('payment', this.order,paymentKey);
              }
            }
          );
  }

  async validatePayment(payment:IPayment){
    console.log('validate payment', payment);
    this.processingMessage = this.translateService.instant('payment.Validating');
    this.order = await this.paymentService.validatePayment(payment.basketKey, payment.paymentKey);
    this.routeAfterPayment('payment', this.order, payment.paymentKey);
  }

  routeAfterPayment(state:string, order:OrderModel, paymentKey:string){
    console.log('check routeafterpayment: order, paymentkey, state',order,paymentKey,state);
    if(state == 'payment' && paymentKey && order.payments[paymentKey]){
      if(order.payments[paymentKey].status =='paid'){
        this.state = 'orderConfirmation';
        console.log('payment succeeded');
        this.goToState('confirmation');
      }
      else if(order.payments[paymentKey].status =='failed' || order.payments[paymentKey].status =='expired' || order.payments[paymentKey].status =='unpaid'){
        console.log('payment failed');
        this.state = 'paymentFailed';
        this.goToState('paymentChoice');
      }
      else if(order.payments[paymentKey].status =='new' || order.payments[paymentKey].status =='waiting'){
        this.state = 'paymentWaiting';
        console.log('payment waiting');
        this.processingMessage = this.translateService.instant('payment.Validating');
        this.goToState("processing");
        this.listenToPaymentUpdate(paymentKey);
      }
    }
  }

  async prev(state: string): Promise<void> {
    if (state == "address") {
      this.goToState('contact');
    } else if (state == "contact") {
      this.goToState('basket');
    } else if (state == "paymentContact") {
      this.goToState('paymentChoice');
    }
    else if (state == "comment") {
      if (this.needsAddress) {
        this.goToState('address');
      } else {
        this.goToState('basket');
      }
    }
    else if (state == "paymentChoice") {
      this.goToState('comment');

    }
  }


  async goToState(state:string){
    console.log()
    this.state = state;
  }

  stayOnTheSlide(onmessage: string): void {
    this.presentToast(onmessage);
    // this.orderSlider.lockSwipes(true);
    this.loading = false;
  }

  public goHome(): void {
    this.homeService.navigateToHome();
  }

  async goToPayment(order: OrderModel): Promise<void> {
    this.goToState('payment');
    // mangopay.cardRegistration.baseURL = paymentConfig.mangopay.baseURL;
    // mangopay.cardRegistration.clientId = paymentConfig.mangopay.clientId;
  }

  showFinalResult(response): void {
    this.goToState('orderConfirmation');
  }

  async confirmOrder() {
    console.log(this.order);
    //this.order.finances.paymentMode = this.tournee.details.paymentModes[this.formComment.value.paymentMode];

    const sourceDetails = this.order.market ? this.order.market.details : this.order.tournee.details;

    let message = "";
    //message += this.order.details.productMode!=='free'?"<h3 class='alert-basket'>Total: "+this.order.finances.totals.sold+"€</h3>":"<h3>Montant: à confirmer prochainement par le producteur</h3>";
    if(this.order.market){
      message +=
      "<h4 class='alert-basket'>" +
      this.translateService.instant("tournee.At") +
      ": </h4><p class='alert-basket'>" +
      sourceDetails.name +
      "</p>";
    }
    else{
      message +=
      "<h4 class='alert-basket'>" +
      this.translateService.instant("tournee.From") +
      ": </h4><p class='alert-basket'>" +
      this.order.producer.details.shortDetails.name +
      "</p>";
    }

    if (sourceDetails.deliveryType == "tournee") {
      message +=
        "<h4 class='alert-basket'>" +
        this.translateService.instant("tournee.TourneeOn") +
        ": </h4><p class='alert-basket'>" +
        new Date(sourceDetails.date).toLocaleDateString() +
        "</p>";
      message +=
        "<h4 class='alert-basket'>" +
        this.translateService.instant("tournee.ToDeliver") +
        ": </h4><p class='alert-basket'>" +
        this.order.route.geocoding.label +
        "</p>";
    } else {
      message +=
        "<h4 class='alert-basket'>" +
        this.translateService.instant("tournee.ToPickUpOn") +
        ": </h4><p class='alert-basket'>" +
        new Date(sourceDetails.date).toLocaleDateString() +
        " " +
        this.translateService.instant("common.between") +
        " " +
        sourceDetails.fromTimeHour +
        " " +
        this.translateService.instant("common.and") +
        " " +
        sourceDetails.toTimeHour +
        "</p>";      
      message +=
        "<h4 class='alert-basket'>" +
        this.translateService.instant("tournee.AtAddress") +
        ": </h4><p class='alert-basket'>" +
        (sourceDetails.geocoding.address.name ? sourceDetails.geocoding.address.name + ", " : "") +
        sourceDetails.geocoding.label +
        "</p>";

    }
    const alert = await this.alertCtrl.create({
      header: this.translateService.instant("tournee.ConfirmOrder"),
      cssClass: "alertMsg",
      message: message,
      backdropDismiss: false,
      buttons: [
        { role: "cancel", text: this.translateService.instant("buttons.Cancel") },
        { role: "ok", text: this.translateService.instant("buttons.Confirm") }
      ]
    });
    await alert.present();
    const alertResult = await alert.onDidDismiss();
    if (alertResult.role == "ok") {
      this.saveOrder();
    } else {
      // this.orderSlider.lockSwipes(false);
      return;
    }
  }

  async saveOrder() {
    this.loading = true;
    this.formComment.disable();
    this.formFullProfile.disable();
    this.order.status = "created";
    this.order = this.mathService.calculateMultiOrder(this.order);
    if (this.order.details.format == "group" && this.order.tournees) {
      for (const tourneeKey in this.order.tournees) {
        this.order.tournees[tourneeKey].status = "created"; // to be checked if correct
        this.order.tournees[tourneeKey].orderStatus = "created";
      }
    }
    const sourceDetails = this.order.market ? this.order.market.details : this.order.tournee.details;
    this.order.details.dateOrdered = Date();
    console.log(this.order);
    if(this.order.key){
      console.log('existing order key');
      // in case the payment failed and the user can still save an order without paying
      try {
        const result = await this.dataService.updateBasketStatus(this.order);
        const details = this.order.market ? this.order.market.details : this.order.tournee.details;
        this.goToState('orderConfirmation');
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.formFullProfile.enable();
        this.formAddress.enable();
        this.formComment.enable();
        // this.orderSlider.lockSwipes(false);
        this.loading = false;
        this.presentToast(this.translateService.instant("errors.ConnectionIssueTryAgainLater") + ": " + error);
      }    }
    else{
      console.log('new order');
      try {
        const result = await this.dataService.createOrder(this.order);
        this.order.key = result.key;
        const details = this.order.market ? this.order.market.details : this.order.tournee.details;
        this.goToState('orderConfirmation');
        this.loading = false;
        //reset order object and empty basket
        this.order.key = null;
        this.order.status = "new";
        this.order.tournees = null;
        this.order.products.references = {};
        this.order.finances = {
            paymentMode: {},
            productCount: 0,
            totals: {
              sold: 0,
              paid: 0
            }
          };
        this.onOrder();
      } catch (error) {
        console.log(error);
        this.formFullProfile.enable();
        this.formAddress.enable();
        this.formComment.enable();
        // this.orderSlider.lockSwipes(false);
        this.loading = false;
        this.presentToast(this.translateService.instant("errors.ConnectionIssueTryAgainLater") + ": " + error);
      }
    }      
    }

  closeToast(): void {
    if (typeof this.toastCtrl != "undefined") {
      this.toastCtrl.dismiss();
    }
  }

  //moved to backend
  async createNotificationConfig(order:OrderModel): Promise<NotificationConfigModel>{
    const currentNotifications = await lastValueFrom(this.dataService.getUserNotifications(order.consumer.key).pipe(take(1)));
    console.log('current notification',currentNotifications);
    const notificationConfigs: NotificationConfigModel = {
      uid:order.consumer.key,
      categories: []
    };
    if(order.market){
      if(order.market.parentKey){
        const channel = {
          email:true,
          app:true
        };
        if(currentNotifications['markets'] && currentNotifications['markets'][order.market.parentKey]){
          channel.email = !!currentNotifications['markets'][order.market.parentKey]['general'][0]['all']['email'];
          channel.app = !!currentNotifications['markets'][order.market.parentKey]['general'][0]['all']['app'];
        } else {
          this.dataService.updateUserNotificationAllChannels(
            notificationConfigs.uid,
            "markets",
            order.market.parentKey,
            "general",
            '0',
            "all",
            true
          );
        }
        const config:NotificationCategoryModel = {
          type:"markets",
          name: order.market.details.name,
          key: order.market.parentKey,
          subCategories:[
            {
              type:'general',
              key:'0',
              action:'all',
              channel: channel
            }
          ]
          
        }
        notificationConfigs.categories.push(config);        
      }

      for(const tourneeKey in order.tournees){
        const channel = {
          email:true,
          app:true
        };
        if(currentNotifications['producers'] && currentNotifications['producers'][order.tournees[tourneeKey].producer.key]){
          channel.email = !!currentNotifications['producers'][order.tournees[tourneeKey].producer.key]['general'][0]['all']['email'];
          channel.app = !!currentNotifications['producers'][order.tournees[tourneeKey].producer.key]['general'][0]['all']['app'];
        } else {
          this.dataService.updateUserNotificationAllChannels(
            notificationConfigs.uid,
            "producers",
            order.tournees[tourneeKey].producer.key,
            "general",
            '0',
            "all",
            true
          );
        }
        const config:NotificationCategoryModel = {
          type:"producers",
          name: order.tournees[tourneeKey].producer.details.shortDetails.name,
          key: order.tournees[tourneeKey].producer.key,
          subCategories: [{
            type:"general",
            key:'0',
            action:"all",
            channel:channel            
          }]
        }
        notificationConfigs.categories.push(config);
      }
      const channel = {
        email:true,
        app:true
      };
      if(currentNotifications['places'] && currentNotifications['places'][order.market.details.geocoding.address.countryCode] 
        && currentNotifications['places'][order.market.details.geocoding.address.countryCode][order.market.details.geocoding.address.city]
        && currentNotifications['places'][order.market.details.geocoding.address.countryCode][order.market.details.geocoding.address.city][order.market.details.geocoding.address.postalCode]){
        channel.email = !!currentNotifications['places'][order.market.details.geocoding.address.countryCode][order.market.details.geocoding.address.city][order.market.details.geocoding.address.postalCode]['all']['email'];
        channel.app = !!currentNotifications['places'][order.market.details.geocoding.address.countryCode][order.market.details.geocoding.address.city][order.market.details.geocoding.address.postalCode]['all']['app'];
      } else {
        this.dataService.updateUserNotificationAllChannels(
          notificationConfigs.uid,
          "places",
          order.market.details.geocoding.address.countryCode,
          order.market.details.geocoding.address.city,
          order.market.details.geocoding.address.postalCode,
          "all",
          true
        );
      }
      const configPlace:NotificationCategoryModel = {
        type:"places",
        key: order.market.details.geocoding.address.countryCode,
        name: order.market.details.geocoding.address.city + '('+order.market.details.geocoding.address.postalCode+')',
        subCategories: [{
          key: order.market.details.geocoding.address.postalCode,
          name: order.market.details.geocoding.address.city,
          type: order.market.details.geocoding.address.city,
          action:"all",
          channel:channel
        }]
      }
      notificationConfigs.categories.push(configPlace);
    }
    else{
      const channel = {
        email:true,
        app:true
      };

      // CHECK IF producer is already in the consumer notification config. If not, add it with all channel set to true.
      if(currentNotifications['producers'] && currentNotifications['producers'][order.producer.key]){
        channel.email = !!currentNotifications['producers'][order.producer.key]['general'][0]['all']['email'];
        channel.app = !!currentNotifications['producers'][order.producer.key]['general'][0]['all']['app'];
      } else {
        this.dataService.updateUserNotificationAllChannels(
          notificationConfigs.uid,
          "producers",
          order.producer.key,
          "general",
          '0',
          "all",
          true
        );
      }
      const config:NotificationCategoryModel = {
        type:"producers",
        name: order.producer.details.shortDetails.name,
        key: order.producer.key,
        subCategories: [{
          type:"general",
          key:"0",
          name: order.producer.details.shortDetails.name,
          action:"all",
          channel:channel
        }]
      }
      if(order.tournee.parentKey){
        const channel = {
          email:true,
          app:true
        };
        if(currentNotifications['producers'] && currentNotifications['producers'][order.producer.key] 
        && currentNotifications['producers'][order.producer.key]['sales']  
          && currentNotifications['producers'][order.producer.key]['sales'][order.tournee.parentKey]){
          channel.email = !!currentNotifications['producers'][order.producer.key]['sales'][order.tournee.parentKey]['all']['email'];
          channel.app = !!currentNotifications['producers'][order.producer.key]['sales'][order.tournee.parentKey]['all']['app'];
        } else {
          this.dataService.updateUserNotificationAllChannels(
            notificationConfigs.uid,
            "producers",
            order.producer.key,
            "sales",
            order.tournee.parentKey,
            "all",
            true
          );
        }
        const subconfig:NotificationSubCategoryModel = {
            type: "sales",
            name: order.tournee.details.name,
            key: order.tournee.parentKey,
            action:"all",
            channel:channel
        }
        config.subCategories.push(subconfig);        
      }
      notificationConfigs.categories.push(config);     
      const channelPlace = {
        email:true,
        app:true
      };
      if(currentNotifications['places'] && currentNotifications['places'][order.tournee.details.geocoding.address.countryCode] 
        && currentNotifications['places'][order.tournee.details.geocoding.address.countryCode][order.tournee.details.geocoding.address.city]
        && currentNotifications['places'][order.tournee.details.geocoding.address.countryCode][order.tournee.details.geocoding.address.city][order.tournee.details.geocoding.address.postalCode]){
        channelPlace.email = !!currentNotifications['places'][order.tournee.details.geocoding.address.countryCode][order.tournee.details.geocoding.address.city][order.tournee.details.geocoding.address.postalCode]['all']['email'];
        channelPlace.app = !!currentNotifications['places'][order.tournee.details.geocoding.address.countryCode][order.tournee.details.geocoding.address.city][order.tournee.details.geocoding.address.postalCode]['all']['app'];
      } else {
        this.dataService.updateUserNotificationAllChannels(
          notificationConfigs.uid,
          "places",
          order.tournee.details.geocoding.address.countryCode,
          order.tournee.details.geocoding.address.city,
          order.tournee.details.geocoding.address.postalCode,
          "all",
          true
        );
      }
      const configPlace:NotificationCategoryModel = {
        type:"places",
        key: order.tournee.details.geocoding.address.countryCode,
        name: order.tournee.details.geocoding.address.city,
        subCategories: [{
          key: order.tournee.details.geocoding.address.postalCode,
          type:order.tournee.details.geocoding.address.city,
          name: order.tournee.details.geocoding.address.city,
          action:"all",
          channel:channelPlace
        }]
      }
      notificationConfigs.categories.push(configPlace);
    }
    console.log("notification configs",notificationConfigs);
    return notificationConfigs;
  }

  openOrder(){
    this.onViewOrder(this.order);
  }

  async presentToast(message: string): Promise<void> {
    const toast = await this.toastCtrl.create({
      message: message,
      duration: 15000,
      buttons: [
        {
          side: "end",
          icon: "close-circle-outline",
          role: "cancel",
          handler: () => {
            console.log("dismiss toast");
            //toast.dismiss();
          }
        }
      ],
      position: "middle"
    });
    toast.present();
  }
  async showLegal(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: LegalComponent,
      cssClass: "modal"
    });
    return await modal.present();
  }
  showPaymentTerms(){
    Browser.open({url:this.translateService.instant('payment.'+this.psp+'.terms'),windowName:'_blank' })
  }

  onCardCancelled(): void {
    this.prev("payment");
  }

  onCardSubmitted(): void {
    //this.paymentService.activatePayment(this.order.consumer);
  }
}
